import React, { useEffect, useCallback } from 'react';
import { observer } from 'mobx-react-lite';
import { status } from 'skin/event/status';
import './style.css';

import Footer from './footer';
import Title from './title';
import Page from 'skin/cmp/page';

import user from 'task/store/action/master';
import ms from 'skin/store/master';
import data from 'skin/store/master/data';
import story from 'skin/store/master/story';
import act from './act';
import m from 'skin/store/mb';

// Ленивая загрузка
// const Func = React.lazy((_) => import('skin/master/func'));

const Master = (props) => {
	const d = JSON.stringify(props.data);
	const code = props.data.code;
	const mb = m.isMobile;

	// Пользовательский action
	const userAct = useCallback(
		(obj, ms, story, data, d, action) => {
			const fnc = user.s[code] ? user.s[code] : user.s.def;
			return fnc(obj, ms, story, data, d, action);
		},
		[code]
	);

	// Стандартный action Мастера по key
	const action = useCallback(
		(obj) => {
			// Выполнение пользовательских action из task/store/action/master
			const val = userAct(obj, ms, story, data, d, action);
			if (!val) return status.action;
			// Выполнение action по умолчанию
			if (act[obj.type]) act[obj.type](obj, data, action, d, ms, story);
			return status.action;
		},
		[userAct, d]
	);

	useEffect(newCode, [d, action]);

	let cls = ['skin-master', 'master'];
	cls = cls.join(' ');
	const { page, item, group, fld, text, table } = ms.s;

	const pageLen = ms.pageLen;

	const current = story.current;
	const curPage = current.page;

	const title = ms.bookTitle;
	const list = ms.pages;
	const nextTitle = ms.getTitle(curPage);

	const { values, errors } = data.curData;

	return (
		<div className={cls}>
			<Title
				action={action}
				title={title}
				current={curPage}
				list={list}
			/>
			<div className="master-content">
				{!mb && 
				<>
				<Page
					idx={curPage}
					page={page}
					item={item}
					group={group}
					fld={fld}
					text={text}
					table={table}
					action={action}
					values={values}
					errors={errors}
					tbl={current?.table}
				/>
				<Footer
					pageCount={pageLen}
					action={action}
					current={curPage}
					nextTitle={nextTitle}
				/>
				</>}
				{mb && 
				<>
				<Footer
					pageCount={pageLen}
					action={action}
					current={curPage}
					nextTitle={nextTitle}
				/>
				<Page
					idx={curPage}
					page={page}
					item={item}
					group={group}
					fld={fld}
					text={text}
					table={table}
					action={action}
					values={values}
					errors={errors}
					tbl={current?.table}
				/>
				</>}
			</div>
		</div>
	);

	// Получение данных для мастера
	function newCode() {
		ms.getDef(d, action, story, data);
	}
};

export default observer(Master);
